// Sidebar badge for Workspace → Tasks: the caller's open assigned tasks.
// Polls like the notification bell so a new assignment shows up without a reload.
import { useQuery } from '@tanstack/react-query'
import { getTaskSummary, staffTaskKeys } from './api'

export function useTaskBadge(): number {
  const summary = useQuery({
    queryKey: staffTaskKeys.summary,
    queryFn: getTaskSummary,
    refetchInterval: 60_000,
    retry: false,
  })
  return summary.data?.assigned_open ?? 0
}
